import styles from './InstallmentDetailsModal.scss';

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Image } from 'src/components/Image/Image';
import { TextV2 } from 'src/components/TextV2/TextV2';
import rockIcon from 'src/images/icons/rock.svg';

import { StructuredModal, StructuredModalState } from 'src/components/StructuredModal/StructuredModal';
import { useCheckout } from '../Checkout/CheckoutProvider';
import { INSTALLMENT_LENGTH, getInstallmentMonth, getInstallmentPlanName } from './InstallmentDetailsUtils';
import { MonthlyDetails } from './MonthlyDetails/MonthlyDetails';

interface InstallmentDetailsModalProps {
  modalState: StructuredModalState;
}

export const InstallmentDetailsModal: FC<InstallmentDetailsModalProps> = ({ modalState }) => {
  const { t } = useTranslation();
  const { selectedPlan } = useCheckout();
  const installmentLength = INSTALLMENT_LENGTH[selectedPlan];

  return (
    <StructuredModal modalState={modalState} title={t('installment-details.installment-plan-details')} variant="slim">
      <TextV2
        value={t('installment-details.interest-free-installments', { installmentPlanName: getInstallmentPlanName(selectedPlan) })}
        variant="h4"
        tagName="h4"
        data-test="installment-sub-title"
      />
      {[...Array(installmentLength)].map((mon, index) => {
        return <MonthlyDetails key={`monthly-details-${index}`} data-test="monthly-details" month={index + 1} installmentLength={installmentLength} />;
      })}
      <div className={styles.containerGreenbar}>
        <Image src={rockIcon} alt={t('installment-details.rockIcon')} data-test="rock-icon" />
        <TextV2
          className={styles.containerGreenInfo}
          variant="body"
          tagName="div"
          value={t('installment-details.system-is-yours', { installmentLength: getInstallmentMonth(installmentLength) })}
        />
      </div>
      <MonthlyDetails month={installmentLength + 1} installmentLength={installmentLength} data-test="after-installment-month" />
      <TextV2
        className={styles.containerFooterText}
        variant="body"
        tagName="div"
        value={t('installment-details.footer')}
      />
    </StructuredModal>
  );
};
